import styled from 'styled-components';

import { notchHeight, Format, macTopBarHeight, navBarHeight } from '../../utils/styles-constants';
import UserAgentUtils from '../../utils/userAgent';

const Wrapper = styled('div')`
	position: absolute;
	top: auto;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 3;
	height: calc(100vh - ${navBarHeight});

	${UserAgentUtils.isMacApp() && `
		height: calc(100vh - ${navBarHeight} - ${macTopBarHeight});
	`}

	${UserAgentUtils.isIOS() && `
		@media ${Format.SmartphonePortrait} and (max-aspect-ratio: 1/2) {
			height: calc(100vh - ${navBarHeight} - ${notchHeight});
		}
	`}

	#wp-notes-editor {
		padding-top: 10px;
	}
`;

export {
	Wrapper,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/NotesEditorPanel/styles.ts